import React, { useEffect, useState } from "react";
import { AxiosApi } from "../../helpers/AxiosApi";
import { useNavigate, useSearchParams } from "react-router-dom";

const Callback = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const [searchParams] = useSearchParams();
  const code_verifier = sessionStorage.getItem("singpass_code_verifier");
  const email = sessionStorage.getItem("email");
  const id = sessionStorage.getItem("id");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const exchangeCodeForToken = async (code) => {
    try {
      setLoading(true);
      setError(null);

      const response = await AxiosApi.post("/singpass-callback", {
        code: code,
        code_verifier: code_verifier,
        email: email,
        id: id,
      });

      // Check if response contains user data
      if (!response || !response.data) {
        throw new Error("No user data received from Singpass");
      }

      const accessToken =
        typeof response === "string" ? response : JSON.stringify(response);

      navigate("/sign-up", {
        state: {
          accessToken: accessToken,
        },
      });
    } catch (error) {
      console.error("Error getting token:", error);
      setError(error);

      // Store error details in session storage for error page
      sessionStorage.setItem(
        "singpass_error",
        JSON.stringify({
          message: error.message || "Failed to retrieve user information",
          timestamp: new Date().toISOString(),
          email: email,
          id: id,
        })
      );

      // Redirect to error page
      navigate("/singpass-error", {
        state: {
          error: error.message || "Failed to retrieve user information",
          email: email,
          id: id,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Check for OAuth error parameters first
    const errorParam = urlParams.get("error");
    const errorDescription = urlParams.get("error_description");
    const errorCode = urlParams.get("error_code");

    if (errorParam) {
      // OAuth error occurred, redirect to error page
      const errorParams = new URLSearchParams();
      if (errorParam) errorParams.set("error", errorParam);
      if (errorDescription)
        errorParams.set("error_description", errorDescription);
      if (errorCode) errorParams.set("error_code", errorCode);

      navigate(`/singpass-error?${errorParams.toString()}`);
      return;
    }

    // Check for authorization code
    const code = urlParams.get("code");
    if (code) {
      exchangeCodeForToken(code);
    } else {
      // No code and no error - invalid callback
      setError(new Error("Invalid callback - no authorization code received"));
      setLoading(false);

      sessionStorage.setItem(
        "singpass_error",
        JSON.stringify({
          message: "Invalid callback - no authorization code received",
          timestamp: new Date().toISOString(),
          email: email,
          id: id,
        })
      );

      navigate("/singpass-error");
    }
  }, [searchParams]);

  if (error && !loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl text-red-600 mb-4">Authentication Error</h2>
          <p className="text-gray-600">Redirecting to error page...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-xl text-gray-700">Singpass Login In Progress...</h2>
        <p className="text-gray-500 mt-2">
          Please wait while we retrieve your information
        </p>
      </div>
    </div>
  );
};

export default Callback;
